import { motion } from "framer-motion";
import { CakeSlice, Images, Star, Tag } from "lucide-react";

const LINKS = [
  { href: "#gallery", label: "Gallery", icon: Images, testid: "quicklink-gallery" },
  { href: "/prices", label: "Prices", icon: Tag, testid: "quicklink-prices" },
  { href: "/servings-guide", label: "Size Guide", icon: CakeSlice, testid: "quicklink-guide" },
  { href: "#testimonials", label: "Reviews", icon: Star, testid: "quicklink-reviews" },
];

export default function QuickLinks() {
  return (
    <section className="relative z-10 mx-auto max-w-4xl px-4 pt-14 sm:px-8" data-testid="quicklinks-section">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {LINKS.map((l, i) => (
          <motion.a
            key={l.label}
            href={l.href}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            data-testid={l.testid}
            className="group flex flex-col items-center gap-2 rounded-2xl border border-gold/40 bg-white/80 px-4 py-5 text-center shadow-sm backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-gold hover:shadow-[0_14px_36px_-12px_rgba(201,162,39,0.5)]"
          >
            <l.icon className="h-5 w-5 text-gold transition-transform duration-300 group-hover:scale-110" />
            <span className="font-serif text-lg font-semibold text-burgundy">{l.label}</span>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
